import {Normalizer, SnapshotEntity} from "../types";

// 'icradosyakaydi' normalizer'i — BorcluIcraDosyasiCevap (uyap/BorcluIcraDosyasi.ts)
// girdisini SnapshotEntity dizisine indirger.
//
// Gercek sekil (parse(), BorcluIcraDosyasi.ts:60-63):
//   cevap.sorguSonucu === true  -> cevap.sorguSonucDVO: Array<IIcraDosyasiSonuc>
//     (parse() her ogeye selected:true ekler, baska hicbir alana dokunmaz).
//   cevap.sorguSonucu === false -> cevap.sorguSonucDVO anahtari HIC YOK (undefined);
//     parse() bu dalda forEach calistirmaz, mock'ta da anahtar zaten bulunmuyor.
//
// Her IIcraDosyasiSonuc kendi 'dosyaId' alanini tasir ama bu SORGULANAN borclunun
// alacakli/borclu oldugu FARKLI bir icra dosyasinin VOLATIL sifreli kimligidir —
// asla entity key'e veya attrs'a girmez (D2/hijyen kurali). Kararli anahtar:
// birimAdi + '|' + dosyaNo.
//
// kod inceleme: yorum dört alanı da normalize ediliyormuş gibi listeliyordu,
// gerçekte yalnizca ikisi attrs'a eklenir. takipYoluAciklamasi ve
// dosyaKapanisTarihiStr opsiyonel alanlardir: Talimat Dosyasi (dosyaTurKodu:1)
// kayitlarinda mock'ta bu alanlar tamamen yok (undefined), Icra Dosyasi
// (dosyaTurKodu:35) kayitlarinda dolu geliyor — yoklugu hataya donusturmeden,
// yalnizca string ise attrs'a eklenir. takipTurAciklamasi ve
// takipSekliciklamasi de ayni DTO'da (uyap/BorcluIcraDosyasi.ts) var ve dolu
// gelebiliyor, ama bu normalizer onlari BİLEREK okumuyor/attrs'a eklemiyor.
export const icradosyakaydiNormalizer: Normalizer = (cevap) => {
    const bos = {entities: []};

    try {
        if (!cevap || typeof cevap !== "object") {
            return bos;
        }

        const liste = cevap.sorguSonucDVO;
        if (!Array.isArray(liste)) {
            // sorguSonucu:false dalinda anahtar hic yok (undefined) — kayit yok demek.
            return bos;
        }

        const entities: SnapshotEntity[] = [];

        for (const kayit of liste) {
            if (!kayit || typeof kayit !== "object") {
                continue;
            }

            const birimAdi: unknown = kayit.birimAdi;
            const dosyaNo: unknown = kayit.dosyaNo;
            if (typeof birimAdi !== "string" || birimAdi.length === 0) {
                continue;
            }
            if (typeof dosyaNo !== "string" || dosyaNo.length === 0) {
                continue;
            }

            const key = birimAdi + "|" + dosyaNo;

            const attrs: Record<string, unknown> = {};
            if (typeof kayit.tarafRolu === "string") {
                attrs.tarafRolu = kayit.tarafRolu;
            }
            if (typeof kayit.dosyaDurumuAciklama === "string") {
                attrs.dosyaDurumuAciklama = kayit.dosyaDurumuAciklama;
            }
            if (typeof kayit.dosyaTurKoduAciklama === "string") {
                attrs.dosyaTurKoduAciklama = kayit.dosyaTurKoduAciklama;
            }
            if (typeof kayit.takipYoluAciklamasi === "string") {
                attrs.takipYoluAciklamasi = kayit.takipYoluAciklamasi;
            }
            if (typeof kayit.dosyaAcilisTarihiStr === "string") {
                attrs.dosyaAcilisTarihiStr = kayit.dosyaAcilisTarihiStr;
            }
            if (typeof kayit.dosyaKapanisTarihiStr === "string") {
                attrs.dosyaKapanisTarihiStr = kayit.dosyaKapanisTarihiStr;
            }

            const label = dosyaNo + " · " + birimAdi;

            entities.push({key, label, attrs});
        }

        return {
            entities,
            ozet: {dosyaSayisi: entities.length}
        };
    } catch {
        // ASLA THROW ETME: beklenmeyen sekil gelirse bos entities don.
        return bos;
    }
};
